/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ExpertDocumentDto = {
    /**
     * Document type
     */
    document_type?: ExpertDocumentDto.document_type;
    /**
     * S3 file key from media/confirm
     */
    file_key?: string;
    /**
     * Original file name
     */
    file_name?: string;
    /**
     * MIME type
     */
    mime_type?: string;
};
export namespace ExpertDocumentDto {
    /**
     * Document type
     */
    export enum document_type {
        CERTIFICATION = 'certification',
        EXPERIENCE = 'experience',
        EDUCATION = 'education',
        OTHER = 'other',
        ID_PROOF = 'id_proof',
    }
}

